import React, { useEffect, useState } from 'react';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import SliderPage from '../components/resuableComponents/SliderPage';
import FandomSection from '../components/resuableComponents/FandomSection';
import Carousel from '../components/resuableComponents/Carousel';
import tapCard from '../assets/images/tap-card.png';
import { Typography } from '@mui/material';
import tapCardImg from "../assets/images/tap-card8.png"
import tapCardImg1 from "../assets/images/tap-card7.png"
import tapCardImg2 from "../assets/images/tap-card6.png"
import qrEverywhereImage from '../assets/images/tap-card5.png';
import openReview from '../assets/images/tap-card2.png';
import leaveFeedback from '../assets/images/tap-card3.png';
import reviewsAnalyticsImage from '../assets/images/tap-card4.png';
import missedReviewImg from '../assets/images/tap-card5.png';
import Carousel2 from '../components/resuableComponents/Carousel2';
import { Box, Grid, useTheme, useMediaQuery, Container } from '@mui/material';
import HomeDrawer from '../components/resuableComponents/HomeDrawer';
import third from '../assets/images/3.png';
import second from '../assets/images/card.jpeg';
import first from '../assets/images/card.jpeg';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-brands-svg-icons';
import circle from '../assets/images/circle.svg';
import CarouselNew from '../components/resuableComponents/CarouselNew';
import Slder from '../components/resuableComponents/Slder';
import TopSelling from '../components/resuableComponents/TopSelling';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import MNavbar from '../components/resuableComponents/Navbar/MobileNav/MNavbar';
import Pricing from '../components/resuableComponents/Pricing';
import exp from '../assets/images/experience.png';
import plan from '../assets/images/planning.png';
import crm from '../assets/images/crm.png';
import order from '../assets/images/rinse.png';
import paid from '../assets/images/paid-ads.png';
import VideoPlayerWithThumbnail from '../components/resuableComponents/VideoPlayerWithThumbnail';
import FAQ from './FAQ';
const slider = [
	'https://img.freepik.com/premium-photo/young-beautiful-lady-going-shopping-holding-bags-smiling-excited-buying-with-discounts-standi_1258-129031.jpg?w=1380',
	'https://img.freepik.com/free-photo/portrat-trendy-feminine-girl-posing-with-shopping-bags-from-store-credit-card-paying-contactl_1258-127340.jpg?w=1380&t=st=1693393561~exp=1693394161~hmac=ad72ac9f57755d0415626a4a63addb9e6bd7cf9ea1049373c09454dd85069a22',
	'https://img.freepik.com/premium-vector/digital-marketing-concept-online-shopping-mobile-application_68971-367.jpg?w=1380',
	'https://img.freepik.com/free-photo/amazed-young-woman-shopaholic-holding-colorful-shopping-bags-look-amused-shop-buying-thi_1258-119761.jpg?w=1380&t=st=1693393797~exp=1693394397~hmac=d4f9c107c63c7a792fd4707b39dce4e9b13106b0bed0471880e19fe83e00787a',
];
const fandom = [
	'https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/product-images/Fandom-Naruto_P4C5r6e.jpg?format=webp&w=480&dpr=1.3',
	'https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/product-images/Fandom-Naruto_P4C5r6e.jpg?format=webp&w=480&dpr=1.3',
	'https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/product-images/Fandom-Naruto_P4C5r6e.jpg?format=webp&w=480&dpr=1.3',
];
const collect = [
	'https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/product-images/collection-tile-Banner_solids_2_O7wgu5E.jpg?format=webp&w=480&dpr=1.0',
	'https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/product-images/collection-tile-Banner_solids_2_O7wgu5E.jpg?format=webp&w=480&dpr=1.0',
	'https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/product-images/collection-tile-Banner_solids_2_O7wgu5E.jpg?format=webp&w=480&dpr=1.0',
	'https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/product-images/collection-tile-Banner_solids_2_O7wgu5E.jpg?format=webp&w=480&dpr=1.0',
];
const top = [
	'https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/product-images/looney-tunes.jpg?format=webp&w=360&dpr=1.3',
	'https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/product-images/looney-tunes.jpg?format=webp&w=360&dpr=1.3',
	'https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/product-images/looney-tunes.jpg?format=webp&w=360&dpr=1.3',
	'https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/product-images/looney-tunes.jpg?format=webp&w=360&dpr=1.3',
	'https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/product-images/looney-tunes.jpg?format=webp&w=360&dpr=1.3',
];
const data = [
	'one stop solution for all type of Reviews QR Code (i.e: google, Facebook, yahoo, tripadvisor, trustpilot, zomato etc',
	'convert any Link into a QR Code',
	'Get a top Google Business Search Ranking with high customer ratings & reviews.',
	'Eliminate Negative Reviews and Rattings from Customer',
	'Carry The card in your pocket or wallet easily',
	'Ask Customer Just one Tap or Scan the Card using their Mobile phone to give you reviews',
	'Private Dshboard to Monitor Negative Reviews of Your customer',
	'NFC Technology Enabled PVC Card with QR Code',
];
const LandingPage = () => {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const navigate = useNavigate();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<>
			{/* <Header /> */}
			<Navbar />
			<MNavbar />
			<div
				style={{
					paddingTop: matches ? 30 : 100,
				}}>
				<Box
					style={{
						paddingLeft: matches ? 30 : 80,
						paddingRight: matches ? 30 : 80,
					}}>
				<Grid container spacing={matches ? 4 : 6} alignItems="center">
  {/* LEFT: Hero Text */}
<Grid item xs={12} lg={6}>
  <Box textAlign={matches ? 'center' : 'left'} style={{ fontFamily: 'Inter, serif' }}>
    <h1
      style={{
        fontSize: matches ? '28px' : '42px',
        fontWeight: 700,
        lineHeight: 1.3,
        color: '#033355',
        marginBottom: '16px',
      }}>
      Supercharge Your Business Growth with 5★ Google Reviews
    </h1>

    <p
      style={{
        fontSize: matches ? '16px' : '20px',
        color: '#555',
        maxWidth: 600,
        margin: '0 auto',
        marginBottom: '32px',
        fontWeight: 400,
        lineHeight: 1.6,
      }}>
      Turn every interaction into a lasting impression. Grow trust, boost visibility, and drive repeat business — all with a single tap
    </p>

    {/* CTA Buttons */}
    <Box
      display="flex"
      flexDirection={matches ? 'column' : 'row'}
      justifyContent={matches ? 'center' : 'flex-start'}
      alignItems="center"
      gap={matches ? 2 : 3}>
      <a
        href=""
        className="ct-link black-demo-button"
        style={{
          backgroundColor: '#033355',
          padding: '14px 28px',
          color: '#ffffff',
          fontWeight: 600,
          fontSize: '16px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(3,51,85,0.2)',
          textDecoration: 'none',
          transition: 'all 0.3s',
          fontFamily: 'Inter, sans-serif',
        }}>
        Demo Card
      </a>
      <a
        href=""
        className="ct-link green-start-free-button"
        style={{
          backgroundColor: '#34c38e',
          padding: '14px 28px',
          color: '#ffffff',
          fontWeight: 600,
          fontSize: '16px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(52,195,142,0.3)',
          textDecoration: 'none',
          transition: 'all 0.3s',
          fontFamily: 'Inter, sans-serif',
        }}>
        Create Card
      </a>
    </Box>
  </Box>
</Grid>


  {/* RIGHT: Video/Image */}
  <Grid item xs={12} lg={6}>
    <Box display="flex" justifyContent="center">
      <VideoPlayerWithThumbnail />
    </Box>
  </Grid>
</Grid>

				</Box>
			</div>
			
			
			<Box mt={matches ? '40px' : '100px'} style={{ fontFamily: 'Inter, serif' }}>
  <h1
    style={{
      fontSize: matches ? 30 : 40,
      fontWeight: 'bold',
      textAlign: 'center',
      color: '#033355',
      marginBottom: '60px',
    }}
  >
    Why Smart Review Qr Code?
  </h1>

  <Container>
    <Grid container spacing={4} justifyContent="center">
      {[
        { img: paid, text: 'More Effective than Paid Ads' },
        { img: order, text: 'Get Repeat Orders from Existing Clients' },
        { img: exp, text: 'Great User Experience' },
        { img: plan, text: 'Reduce Marketing Effort' },
        { img: crm, text: 'Build Long-term Customer Relationships' },
      ].map((item, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Box
            style={{
              border: '1px solid #34c38e',
              padding: 24,
              borderRadius: 15,
              height: '100%',
              transition: '0.3s ease',
              textAlign: 'center',
            }}
          >
            <Box display="flex" justifyContent="center" mb={2}>
              <img src={item.img} alt={item.text} style={{ height: 120 }} />
            </Box>
            <p
              style={{
                fontSize: 16,
                color: '#333',
                fontWeight: 500,
                lineHeight: 1.5,
              }}
            >
              {item.text}
            </p>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Container>
</Box>




			
<Box
  mt={matches ? '40px' : '80px'}
  px={matches ? 2 : 10}
  style={{ fontFamily: 'Inter, serif' }}
>
  <h1
    style={{
      fontSize: matches ? 28 : 42,
      fontWeight: 700,
      textAlign: 'center',
      marginBottom: matches ? 30 : 60,
      color: '#0B2B3C',
    }}
  >
    How It Works?
  </h1>

  <Grid container spacing={matches ? 4 : 6} justifyContent="center">
    {/* Step 1 */}
    <Grid item xs={12} md={4}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        sx={{
          p: 4,
          borderRadius: 4,
          backgroundColor: '#ffffff',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.05)',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 12px 28px rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        <img
          src={tapCard}
          alt="Tap the Card"
          style={{ width: '100%', maxWidth: 220, marginBottom: 24 }}
        />
        <h2
          style={{
            fontSize: 20,
            fontWeight: 600,
            color: '#033355',
            marginBottom: 12,
          }}
        >
          Tap the Card
        </h2>
        <p style={{ fontSize: 16, color: '#555', lineHeight: 1.6 }}>
          A quick tap with any NFC-enabled phone starts the review journey instantly.
        </p>
      </Box>
    </Grid>

    {/* Step 2 */}
    <Grid item xs={12} md={4}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        sx={{
          p: 4,
          borderRadius: 4,
          backgroundColor: '#ffffff',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.05)',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 12px 28px rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        <img
          src={openReview}
          alt="Open Review Page"
          style={{ width: '100%', maxWidth: 220, marginBottom: 24 }}
        />
        <h2
          style={{
            fontSize: 20,
            fontWeight: 600,
            color: '#033355',
            marginBottom: 12,
          }}
        >
          Open the Review Page
        </h2>
        <p style={{ fontSize: 16, color: '#555', lineHeight: 1.6 }}>
          The customer is instantly taken to your Google Review page — no login or search.
        </p>
      </Box>
    </Grid>

    {/* Step 3 */}
    <Grid item xs={12} md={4}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        sx={{
          p: 4,
          borderRadius: 4,
          backgroundColor: '#ffffff',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.05)',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 12px 28px rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        <img
          src={leaveFeedback}
          alt="Leave Feedback"
          style={{ width: '100%', maxWidth: 220, marginBottom: 24 }}
        />
        <h2
          style={{
            fontSize: 20,
            fontWeight: 600,
            color: '#033355',
            marginBottom: 12,
          }}
        >
          Leave Feedback
        </h2>
        <p style={{ fontSize: 16, color: '#555', lineHeight: 1.6 }}>
          In just seconds customer shares a 5★ review — boosting the reputation.
        </p>
      </Box>
    </Grid>
  </Grid>
</Box>






<Box
  mt={matches ? '40px' : '80px'}
  px={matches ? 2 : 8}
  py={matches ? 5 : 7}
  style={{
  
	marginTop:"20px",
    borderRadius: '16px',
    fontFamily: 'Inter, serif',
  }}
>
  <Grid container spacing={5} alignItems="center">
    {/* IMAGE */}
    <Grid item xs={12} md={6}>
      <img
        src={reviewsAnalyticsImage} // Replace with your actual image path
        alt="Customer Feedback"
        style={{
          width: '100%',
          maxWidth: 480,
          display: 'block',
          margin: '0 auto',
        }}
      />
    </Grid>

    {/* TEXT */}
    <Grid item xs={12} md={6}>
      <h2
        style={{
          fontSize: matches ? '22px' : '34px',
          fontWeight: 700,
          color: '#033355',
          marginBottom: '16px',
          textAlign: matches ? 'center' : 'left',
        }}
      >
       Your Google Ratings, Supercharged by Simplicity
      </h2>

      <p
        style={{
          fontSize: matches ? '15px' : '17px',
          color: '#444',
          lineHeight: 1.7,
          marginBottom: '28px',
          textAlign: matches ? 'center' : 'left',
        }}
      >

      At Sumahi Media, we build digital solutions that drive results. That’s why we created SumahiQR — a seamless tool designed to help businesses like yours collect genuine Google reviews with zero friction.
<br />

With just one tap or scan of a Smart QR Card, your customers are taken straight to your Google review page — no apps, no logins, no confusion. It's fast, intuitive, and built to convert.
<br />

This effortless experience encourages more 5★ ratings from satisfied clients, helping boost your online visibility, credibility, and local search rankings.
<br />

In a digital world where reviews influence over 90% of buying decisions, your online reputation is your strongest marketing asset. Let SumahiQR help you grow it — one happy customer at a time.

      </p>

      <Box
        display="flex"
        flexDirection={matches ? 'column' : 'row'}
        alignItems="center"
        justifyContent={matches ? 'center' : 'flex-start'}
        gap={2}
      >
        <a
          href="#"
          style={{
            backgroundColor: '#34c38e',
            color: '#fff',
            padding: '14px 28px',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: 600,
            fontSize: '16px',
			justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(52,195,142,0.3)',
            transition: 'all 0.3s ease',
          }}
        >
          Start Collecting Reviews
        </a>

       
	   
      </Box>
    </Grid>
  </Grid>
</Box>





<Box
  mt={matches ? '50px' : '100px'}
  px={matches ? 2 : 10}
  py={matches ? 6 : 10}
  style={{
    backgroundColor: '#f2f7f6ff',
    borderRadius: '16px',
	marginTop: "10px",
    fontFamily: 'Inter, serif',
  }}
>
  <Grid container spacing={6} alignItems="center">
    <Grid item xs={12} md={6}>
      <h2
        style={{
          fontSize: matches ? 24 : 36,
          fontWeight: 700,
          color: '#033355',
          marginBottom: 10,
		 
		  
        }}
      >
        Power of Every Customer Interaction
      </h2>

      <p
        style={{
          fontSize: matches ? 16 : 17,
          color: '#444',
          lineHeight: 1.6,
          marginBottom: 24,
        }}
      >
        At Sumahi Media, we specialize in building smart digital solutions to elevate your brand online. This website was developed with one clear goal — to help businesses like yours effortlessly collect Google reviews and strengthen their online reputation.
<br></br>
In today's competitive digital space, Google ratings play a critical role in customer decisions. Our Smart Review tools are designed to make the process frictionless — allowing your customers to leave a review instantly with a simple tap or scan.
<br></br>
No apps. No delays. Just real feedback — helping you improve visibility, build trust, and grow faster through authentic customer ratings.
      </p>

     
     

      <a
        href=""
        style={{
          backgroundColor: '#34c38e',
          color: '#fff',
          padding: '14px 28px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontWeight: 600,
          fontSize: '16px',
          boxShadow: '0 4px 12px rgba(52,195,142,0.3)',
        }}
      >
        Make Every Customer Count
      </a>
    </Grid>

    <Grid item xs={12} md={6}>
      <img
        src={missedReviewImg} // replace with relevant visual
        alt="Missed Opportunity"
        style={{ width: '100%', maxWidth: 520 }}
      />
    </Grid>
  </Grid>
</Box>






			
			
			<Box mt={matches ? '40px' : '80px'} px={matches ? 2 : 10}>
  <h1
    style={{
      fontSize: matches ? 28 : 40,
      fontWeight: '700',
      textAlign: 'center',
      marginBottom: matches ? 30 : 60,
      color: '#0B2B3C',
      fontFamily: 'Inter, serif',
    }}
  >
    Features of Smart Review QR Code
  </h1>

  <Container>
    <Grid container spacing={matches ? 3 : 4}>
      {data.map((feature, index) => (
        <Grid item xs={12} md={6} key={index}>
          <Box
            display="flex"
            alignItems="flex-start"
            sx={{
              backgroundColor: '#ffffff',
              borderRadius: '12px',
              padding: matches ? 2 : 3,
              boxShadow: '0 6px 20px rgba(0,0,0,0.05)',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-6px)',
                boxShadow: '0 12px 24px rgba(0,0,0,0.1)',
              },
            }}
          >
            <img
              src={circle}
              alt="check icon"
              style={{
                height: 24,
                marginTop: 4,
                marginRight: 16,
              }}
            />
            <p
              style={{
                fontSize: matches ? 14 : 16,
                color: '#333',
                lineHeight: 1.5,
                fontFamily: 'Inter, serif',
                margin: 0,
              }}
            >
              {feature}
            </p>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Container>
</Box>

			<img src={second} style={{ width: '100%', marginTop: 40 }} />


<Box
  mt={matches ? '40px' : '80px'}
  px={matches ? 2 : 10}
  py={matches ? 4 : 8}
  sx={{ fontFamily: 'Inter, serif' }}
>
  <Typography
    variant="h4"
    sx={{
      fontSize: matches ? 26 : 34,
      fontWeight: 700,
      textAlign: 'center',
      color: '#033355',
      mb: 6,
	  marginTop: "-50px",
	  fontFamily: 'Inter, serif',
    }}
  >
    Choose Your Smart Review Tool
  </Typography>

  <Grid container spacing={matches ? 4 : 8} justifyContent="center">
    {[
      {
        title: 'Smart Review Card',
        desc: 'Tap or scan to instantly leave a Google Review. Pocket-sized power for your team or counter.',
        image: tapCardImg,
      },
      {
        title: 'NFC Tag ',
        desc: 'Stick it anywhere — laptops, doors, packaging. Just one tap to collect reviews on the go.',
        image: tapCardImg1,
      },
      {
        title: 'Display Stand',
        desc: 'Place at counters or reception. Eye-catching and review-ready — no explanation needed.',
        image: tapCardImg2,
      },
    ].map((product, index) => (
      <Grid item xs={12} sm={6} md={4} key={index} textAlign="center">
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <img
            src={product.image}
            alt={product.title}
            style={{
              width: '100%',
              maxWidth: 350,
              objectFit: 'contain',
            }}
          />
        </Box>
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, color: '#022b3a', mb: 1, fontSize: 20,fontFamily: 'Inter, serif' }}
        >
          {product.title}
        </Typography>
        <Typography sx={{ fontSize: 17, color: '#555', maxWidth: 300, mx: 'auto',fontFamily: 'Inter, serif' }}>
          {product.desc}
        </Typography>
      </Grid>
    ))}
  </Grid>
</Box>

<a
  href="https://wa.me/918074251396"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 1000,
  }}
>
  <img
    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
    alt="WhatsApp"
    style={{ width: '50px', height: '50px' }}
  />
</a>



			{/* <Pricing /> */}
			{/* <img src={first} style={{ width: '100%', marginTop: 40 }} /> */}
			
			
			<FAQ />
			<Footer />
		</>
	);
};

export default LandingPage;
